
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class RawMaterialMasterSelectGrid extends Serenity.EntityGrid<RawMaterialMasterRow, any> {
        protected getColumnsKey() { return 'OMS.RawMaterialMaster'; }
        protected getDialogType() { return <any>RawMaterialMasterDialog; }
        protected getIdProperty() { return RawMaterialMasterRow.idProperty; }
        protected getLocalTextPrefix() { return RawMaterialMasterRow.localTextPrefix; }
        protected getService() { return RawMaterialMasterService.baseUrl; }
        //protected getInsertPermission() { return RawMaterialMasterRow.insertPermission; }
        //protected getUpdatePermission() { return RawMaterialMasterRow.updatePermission; }
        //protected getDeletePermission() { return RawMaterialMasterRow.deletePermission; }
        //protected useViewMode() { return true; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            return this;
        }

        get selectedItems(): RawMaterialMasterRow[] {
                var _this = this;
                return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideRawMaterialMasters && this.options.hideRawMaterialMasters.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["RawMaterialMasterID" /* RawMaterialMasterID */], 'not in', [this.options.hideRawMaterialMasters]]);
            return true;
           
        }
        
    }

    export interface RawMaterialMasterSelectOptions {
        ParentKey?: string;
        Key?: string;
        Title?: string;
        IsGroup?: boolean;
        GrantRevoke?: boolean;
    }
}